import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-heading4.scss';
import '../font.scss';

const FontHeading4: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY2 : props.color
    };

    return (
        <h4 className={`font font-heading4 ${fontClasses(props)}`}>{props.children}</h4>
    )
};

export default FontHeading4;
